import React from "react";
import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";
import { useWidth } from "custom-hooks/use-width.hook";
import SlickSlider from "../slick-slider";
import { css } from "@emotion/react";
import { Grid, styled } from "@mui/material";

function CustomCarrusel(props: {
  children: any;
  colorArrow?: string;
  placeholderItem?: JSX.Element;
  enablePlaceholder?: boolean;
  numberOfPlaceholderItems?: number;
  forcePlaceHolder?: boolean;
}) {
  const width = useWidth();
  const rows = {
    xs: 1,
    sm: 1,
    md: 2,
    lg: 3,
    xl: 4,
  };

  const arrowsLeft = css`
    color: ${props.colorArrow ?? "var(--color-brand-blue-main)"} !important;
    font-size: clamp(1.5rem, 2.5vw, 2.6rem);
    padding: 2px;
    position: absolute;
    z-index: 500;
    left: ${width === "xs" || width === "sm" ? "-25px" : "-50px"} !important;
    top: 50%;
    transform: translateY(-50%);

    @media (max-width: 600px) {
      left: -15px !important;
      font-size: 1.8rem;
    }
  `;

  const arrowsRight = css`
    color: ${props.colorArrow ?? "var(--color-brand-blue-main)"} !important;
    font-size: clamp(1.5rem, 2.5vw, 2.6rem);
    padding: 2px;
    position: absolute;
    z-index: 500;
    right: ${width === "xs" || width === "sm" ? "-25px" : "-50px"} !important;
    top: 50%;
    transform: translateY(-50%);

    @media (max-width: 600px) {
      right: -15px !important;
      font-size: 1.8rem;
    }
  `;

  const settings = {
    dots: false,
    infinite: props.children?.length > rows[width],
    speed: 500,
    slidesToShow: rows[width],
    slidesToScroll: 1,
    centerMode: false,
    nextArrow: <ArrowForwardIosRoundedIcon css={arrowsRight} />,
    prevArrow: <ArrowBackIosNewRoundedIcon css={arrowsLeft} />,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          centerMode: false,
        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          centerMode: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false,
        },
      },
    ],
  };

  const fakeElements = Array.from(
    { length: props.numberOfPlaceholderItems ?? 5 },
    (v, i) => i
  );

  return (
    <CarruselContainer container justifyContent="center">
      <Grid item xs={11} sm={11} md={11} lg={10} xl={10} my={"auto"}>
        <SlickSlider {...settings}>
          {!props?.children &&
            props.enablePlaceholder &&
            fakeElements.map((e, i) =>
              React.cloneElement(props.placeholderItem as any, { key: i })
            )}
          {props?.children && props.children}
        </SlickSlider>
      </Grid>
    </CarruselContainer>
  );
}

export default CustomCarrusel;

const CarruselContainer = styled(Grid)`
  position: relative;
  
  & .slick-slider {
    position: relative;
  }
  
  & .slick-arrow {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 10;
    
    &:before {
      display: none;
    }
  }
  
  & .slick-prev {
    left: -40px;
    
    @media (max-width: 900px) {
      left: -25px;
    }
    
    @media (max-width: 600px) {
      left: -10px;
    }
  }
  
  & .slick-next {
    right: -40px;
    
    @media (max-width: 900px) {
      right: -25px;
    }
    
    @media (max-width: 600px) {
      right: -10px;
    }
  }
  
  & .slick-list {
    overflow: hidden;
  }
  
  & .slick-track {
    display: flex;
    align-items: stretch;
  }
  
  & .slick-slide {
    > div {
      height: 100%;
    }
  }
`;
